import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[Kuiva]', error, info.componentStack);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[100dvh] min-h-screen flex-col items-center justify-center gap-6 bg-background px-6 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-destructive/10 text-destructive">
            <AlertTriangle className="h-8 w-8" aria-hidden />
          </div>
          <div className="max-w-md space-y-2">
            <h1 className="text-xl font-bold text-foreground">Algo correu mal</h1>
            <p className="text-sm text-muted-foreground">
              Não foi possível mostrar esta página. Tenta atualizar ou volta mais tarde.
            </p>
          </div>
          <button
            type="button"
            onClick={this.handleRetry}
            className="rounded-xl bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-sm transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            Atualizar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
